import React, { useState, useEffect } from 'react';

function AddressAndTaxIdGroup({register, errors, translations}) {
  return (
    <div>
      <div className="form__group form__group--text text-center">
        <h2 className="form__title">{translations.firstHeader}</h2>
      </div>

      <div className="input-group form__group col-10 col-sm-9 mx-auto">
        <input ref={register} className="string optional" placeholder={translations.fullName} type="text" name="form_data[full_name]" id="form_data_full_name" />
        <span className="input__text text-danger">{errors.form_data_full_name && errors.form_data_full_name.message}</span>
      </div>

      <div className="input-group form__group col-10 col-sm-9 mx-auto">
        <input ref={register} className="string optional" placeholder={translations.companyName} type="text" name="form_data[company_name]" id="form_data_company_name" />
        <span className="input__text text-danger">{errors.form_data_company_name && errors.form_data_company_name.message}</span>
      </div>

      <div className="input-group form__group col-10 col-sm-9 mx-auto">
        <input ref={register} className="string optional" placeholder={translations.streetAddress} type="text" name="form_data[street_address]" id="form_data_street_street" />
        <span className="input__text text-danger">{errors.form_data_street_address && errors.form_data_street_address.message}</span>
      </div>

      <div className="input-group form__group col-10 col-sm-9 mx-auto">
        <input ref={register} className="string optional" placeholder={translations.city} type="text" name="form_data[city]" id="form_data_city" />
        <span className="input__text text-danger">{errors.form_data_city && errors.form_data_city.message}</span>
      </div>

      <div className="input-group form__group col-10 col-sm-9 mx-auto">
        <input ref={register} className="string optional" placeholder={translations.postalCode} type="text" name="form_data[postal_code]" id="form_data_postal_code" />
        <span className="input__text text-danger">{errors.form_data_postal_code && errors.form_data_postal_code.message}</span>
      </div>

      <div className="input-group form__group col-10 col-sm-9 mx-auto">
        <select ref={register} className="form_group select required" name="form_data[country_code]" id="form_data_country_code">
          <option value="">{translations.countryCode}</option>
          <option value="pl">{translations.poland}</option>
          <option value="en">{translations.england}</option>
          <option value="nn">{translations.norway}</option>
        </select>
        <span className="input__text text-danger">{errors.form_data_country_code && errors.form_data_country_code.message}</span>
      </div>

      <div className="input-group form__group col-10 col-sm-9 mx-auto">
        <input ref={register} className="string optional" placeholder={translations.taxId} type="text" name="form_data[tax_id]" id="form_data_tax_id" />
        <span className="input__text text-danger">{errors.form_data_tax_id && errors.form_data_tax_id.message}</span>
      </div>
    </div>
  );
};

export default AddressAndTaxIdGroup;
